
import { computed, defineComponent, onMounted, ref } from "vue";
import FilterHistory from "../components/filter-history.vue";
import {
  HistoryHanging,
  HistoryHangingIncomingFilterRequest,
  RiwayatHangingLasmileRequest
} from "@/domain/entities/HangingIncoming";
import { SttHangingController } from "@/app/ui/controllers/SttHangingController";
import { debounce } from "lodash";
import {
  formatDate,
  parsingErrorResponse
} from "@/app/infrastructures/misc/Utils";
import PaginationV3 from "@/app/ui/components/pagination-v3/index.vue";
import moment from "moment";
import {
  getHangingStyle,
  getStatusLabel,
  getStatusStyle,
  getHangingLabel
} from "../shared/modules";
import { TableErrorResponse } from "@/domain/entities/MainApp";

export default defineComponent({
  name: "TabHistoryHangingOutgoing",
  components: { FilterHistory, PaginationV3 },
  setup() {
    // ----------------------------------------------------------
    // State
    // ----------------------------------------------------------
    const dataTable = ref<HistoryHanging>(new HistoryHanging());

    // ----------------------------------------------------------
    // Methods
    // ----------------------------------------------------------
    const getHistoryHanging = async () => {
      try {
        dataTable.value.loading = true;

        const {
          params,
          pagination: { page }
        } = dataTable.value;

        dataTable.value.params.page = page;
        dataTable.value.error = new TableErrorResponse();

        const res = await SttHangingController.getHistoryHangingOutgoing(
          new RiwayatHangingLasmileRequest({
            ...params,
            days: params.days?.length ? params.days.join(",") : "",
            startDate: params.startDate
              ? moment(params.startDate).format("YYYY-MM-DD")
              : "",
            endDate: params.endDate
              ? moment(params.endDate).format("YYYY-MM-DD")
              : ""
          })
        );

        const { days, endDate, existenceStatus, search, startDate } = params;
        dataTable.value = new HistoryHanging({
          ...res,
          params: dataTable.value.params,
          error: new TableErrorResponse({
            params: [
              days?.length,
              endDate,
              existenceStatus,
              search,
              startDate
            ].join(""),
            totalData: res.data.length
          })
        });
      } catch (error) {
        dataTable.value = new HistoryHanging({
          ...dataTable.value,
          error: new TableErrorResponse({
            error,
            onRetry: getHistoryHanging
          }),
          data: []
        });
      } finally {
        dataTable.value.loading = false;
      }
    };

    const getByFilter = debounce(
      (params: HistoryHangingIncomingFilterRequest) => {
        dataTable.value.pagination.page = 1;
        dataTable.value.params = params;
        getHistoryHanging();
      },
      250
    );

    const filter = (params: HistoryHangingIncomingFilterRequest) => {
      dataTable.value.loading = true;
      getByFilter(params);
    };

    // ----------------------------------------------------------
    // Computed
    // ----------------------------------------------------------
    const offset = computed(
      () =>
        dataTable.value.pagination.limit * (dataTable.value.pagination.page - 1)
    );

    // ----------------------------------------------------------
    // Lifecycle
    // ----------------------------------------------------------
    onMounted(async () => {
      await getHistoryHanging();
    });

    return {
      dataTable,
      filter,
      offset,
      getHistoryHanging,
      formatDate,
      getHangingStyle: getHangingStyle,
      getStatusLabel: getStatusLabel,
      getStatusStyle: getStatusStyle,
      getHangingLabel: getHangingLabel
    };
  }
});
